module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jpI4r"))).then(() => module.bundle.root('ikE14'));